var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"primary","text":"","block":"","loading":_vm.loading},on:{"click":function($event){return _vm.handler()}}},[_vm._v("Order This Again")])
}
var staticRenderFns = []

export { render, staticRenderFns }